import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    card: {
      position: "relative",
      zIndex: 0,
      backgroundColor: theme.palette.placeholder,
      minHeight: 1,
      width: "100%",
    },
    cardImg: {
      width: "-webkit-fill-available",
      fallbacks: [{ width: "-moz-available" }],
      display: "block",
      maxWidth: "100%",
      height: "auto",
    },
    overlay: {
      pointerEvents: "none",
      position: "absolute",
      zIndex: 2,
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(37, 45, 95, 0.7)",
      display: "flex",
      transform: "visibility 0.1s ease-in",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
    },
    overlayBtn: {
      marginTop: "20px",
      "&:hover": {
        transform: "none",
      },
      [theme.breakpoints.down(500)]: {
        padding: "0 10px",
      },
    },
    smallOverlayBtnClip: {
      marginTop: 20,
      "&:hover": {
        transform: "none",
      },
      padding: [0, 10],
      height: 30,
    },
  }),
  { name: "StarringYou" },
);
